class TimerManager {
	private timers: Map<HTMLElement, number> = new Map();

	set(element: HTMLElement, callback: () => void, delay: number): void {
		this.clear(element);
		const timerId = window.setTimeout(callback, delay);
		this.timers.set(element, timerId);
	}

	clear(element: HTMLElement): void {
		const timerId = this.timers.get(element);
		if (timerId) {
			clearTimeout(timerId);
			this.timers.delete(element);
		}
	}

	clearAll(): void {
		this.timers.forEach((timerId) => clearTimeout(timerId));
		this.timers.clear();
	}
}

export default TimerManager;
